import { createAction } from 'redux-actions';
import {
  SET_ACTIVE_SERVICE_CENTER,
  GET_IS_DECIMAL_REQUEST,
  GET_IS_DECIMAL_SUCCESS,
  GET_IS_DECIMAL_FAILURE,
} from './constants';

export const setActiveServiceCenter = createAction(SET_ACTIVE_SERVICE_CENTER);

export const getIsDecimal = createAction(GET_IS_DECIMAL_REQUEST);
export const getIsDecimalSuccess = createAction(GET_IS_DECIMAL_SUCCESS);
export const getIsDecimalFailure = createAction(GET_IS_DECIMAL_FAILURE);

export default setActiveServiceCenter;
